const Show = (props) => {
  return !!props["r-if"] ? props.children : null;
};

export default Show;
